import PanelCard from '@components/display/cards/PanelCard';
import { VictronWebsiteApiTabValues } from '@developers/types';
import { FormattedMessage } from 'react-intl';

const Content: Record<
    VictronWebsiteApiTabValues,
    {
        article: { title: React.ReactNode; description: React.ReactNode };
        aside?: { url: string; json: Record<string, any> };
    }
> = {
    [VictronWebsiteApiTabValues.ProductInformation]: {
        article: {
            title: (
                <FormattedMessage
                    id="developers.victronwebsiteapi.product_information_title"
                    defaultMessage="Product Information"
                />
            ),
            description: (
                <FormattedMessage
                    id="developers.victronwebsiteapi.product_information_description"
                    defaultMessage="Using the Victron Website API you can automatically update the product information on your website. 
                    You can get product information like: titles, categories, descriptions and SKU. 
                    You can use the SKU codes to link the products with E-Order API."
                />
            ),
        },
        aside: {
            url: 'https://www.victronenergy.com/api/v1/products/',
            json: {
                id: 1,
                name: 'Phoenix Inverter 3000VA - 5000VA',
                short_name: 'Phoenix Inverter',
                category: 'Inverters',
                description: 'Pure sine wave output...',
                modified_at: '2016-01-07 15:38:22',
                sku: ['PIN123020000', 'PIN243020000'],
            },
        },
    },
    [VictronWebsiteApiTabValues.ProductPhotos]: {
        article: {
            title: (
                <FormattedMessage
                    id="developers.victronwebsiteapi.product_photos_title"
                    defaultMessage="Product Photos"
                />
            ),
            description: (
                <FormattedMessage
                    id="developers.victronwebsiteapi.product_photos_description"
                    defaultMessage="For the best UI experience, we recommend sourcing high-resolution product imagery directly from the victronenergy.com. 
                    Using official assets ensures visual consistency and up-to-date branding across your integration."
                />
            ),
        },
        aside: {
            url: 'https://www.victronenergy.com/api/v1/products/',
            json: {
                id: 1,
                name: 'Phoenix Inverter 3000VA - 5000VA',
                '...': '...',
                documents: [
                    {
                        name: 'Phoenix Inverter 24V / 5000 VA (left)',
                        document_type: 'High quality photo',
                        url: 'https://www.victronenergy.com/upload/...',
                        notes: 'Left side of the Phoenix Inverter',
                    },
                    {
                        name: 'Phoenix Inverter 24V / 5000 VA (right)',
                        document_type: 'High quality photo',
                        url: 'https://www.victronenergy.com/upload/...',
                        notes: 'Right side of the Phoenix Inverter',
                    },
                ],
            },
        },
    },
    [VictronWebsiteApiTabValues.ProductDocuments]: {
        article: {
            title: (
                <FormattedMessage
                    id="developers.victronwebsiteapi.product_documents_title"
                    defaultMessage="Product Documents"
                />
            ),
            description: (
                <FormattedMessage
                    id="developers.victronwebsiteapi.product_documents_description"
                    defaultMessage="Keep your users up-to-date without the manual overhead. 
                    This endpoint automatically serves the latest product datasheets and manuals directly from the source, ensuring your customers always have the most current technical specs."
                />
            ),
        },
        aside: {
            url: 'https://www.victronenergy.com/api/v1/products/',
            json: {
                id: 1,
                name: 'Phoenix Inverter 3000VA - 5000VA',
                '...': '...',
                documents: [
                    {
                        name: 'Remote VEConfigure',
                        document_type: 'Manual',
                        url: 'https://www.victronenergy.com/documents/...',
                        notes: 'Summary on page 6',
                    },
                    {
                        name: 'SolarSwitch',
                        document_type: 'Brochure',
                        url: 'https://www.victronenergy.com/documents/...',
                        notes: ' ',
                    },
                ],
            },
        },
    },
};

export const VictronWebsiteAPITabContent = ({ tab }: { tab: VictronWebsiteApiTabValues }) => (
    <>
        <PanelCard component="article" header={Content[tab].article.title} body={Content[tab].article.description} />
        <PanelCard.Code component="aside" url={Content[tab].aside?.url ?? ''} json={Content[tab].aside?.json ?? {}} />
    </>
);
